'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('station_areas', {
      url: '/account/compliance/stationareas',
      template: '<station-areas></station-areas>'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/compliance/station_areas/station_areas.routes.js